import React from "react";
import { Alert, Button } from "reactstrap";

// Inline replacement for a page or list that failed to load, so the screen
// says what happened instead of staying blank.
const LoadError = ({ message, onRetry, busy = false, className = "" }) => (
  <Alert
    color="danger"
    className={`d-flex align-items-center justify-content-between ${className}`}
  >
    <span className="mr-3">{message}</span>
    {onRetry && (
      <Button
        color="danger"
        outline
        size="xs"
        onClick={onRetry}
        disabled={busy}
      >
        {busy ? "Retrying…" : "Retry"}
      </Button>
    )}
  </Alert>
);

export default LoadError;
